/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Wizard_Choose_Kind_FirstInputs */

const vi_stocktake_wizard_choose_kind_first = /** @type {(inputs: Stocktake_Wizard_Choose_Kind_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn loại lô trước để hiển thị chốt sổ.`)
};

/**

* @param {Stocktake_Wizard_Choose_Kind_FirstInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_wizard_choose_kind_first = /** @type {((inputs?: Stocktake_Wizard_Choose_Kind_FirstInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Wizard_Choose_Kind_FirstInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_wizard_choose_kind_first(inputs)
});